import { IStoreState } from "../initialStoreState";
import { defaultStudent, defaultStudentState } from "./studentState";

import produce from "immer";
import { StudentActions } from ".";
import { LoadState } from "../../constants/enums";
import { ADD_CUSTOMER_FULL_DETAILS_SUCCESS, CLEAR_STUDENT, CLEAR_STUDENT_STATE, FETCH_CUSTOMER_FULL_DETAILS_FAILED, FETCH_CUSTOMER_FULL_DETAILS_PROGRESS, FETCH_FEE_TRANINSTION_LIST_FAILED, FETCH_FEE_TRANINSTION_LIST_PROGRESS, FETCH_FEE_TRANINSTION_LIST_SUCCESS, FETCH_STUDENT_FAILED, FETCH_STUDENT_PROGRESS, FETCH_STUDENT_SUCCESS } from "./studentActions";

export const studentReducer = (
  state: IStoreState["student"] = defaultStudentState,
  action: StudentActions
) => {
  switch (action.type) {
    case FETCH_CUSTOMER_FULL_DETAILS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.InProgress;
        draftState.list.data = [];
        draftState.list.totalRecords = 0;
      });
      return newState;
    }
    case ADD_CUSTOMER_FULL_DETAILS_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.data = data;
        draftState.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_CUSTOMER_FULL_DETAILS_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.InProgress;
        draftState.list.data = [];
        draftState.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_STUDENT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.student.loading = LoadState.InProgress;
        draftState.student.data = defaultStudent;
      });
      return newState;
    }
    case FETCH_STUDENT_SUCCESS: {
      const { Student } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.student.loading = LoadState.Loaded;
        draftState.student.data = Student;
      });
      return newState;
    }
    case FETCH_STUDENT_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.student.loading = LoadState.Failed;
        draftState.student.error = errorMessage;
      });
      return newState;
    }
    case FETCH_FEE_TRANINSTION_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.feeTransitionlist.loading = LoadState.InProgress;
        draftState.feeTransitionlist.data = [];
        draftState.feeTransitionlist.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_FEE_TRANINSTION_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.feeTransitionlist.loading = LoadState.Loaded;
        draftState.feeTransitionlist.data = data;
        draftState.feeTransitionlist.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_FEE_TRANINSTION_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.feeTransitionlist.loading = LoadState.InProgress;
        draftState.feeTransitionlist.data = [];
        draftState.feeTransitionlist.totalRecords = 0;
      });
      return newState;
    }

    case CLEAR_STUDENT: {
      const newState = produce(state, (draftState) => {
        draftState.student.loading = LoadState.NotLoaded;
        draftState.student.data = defaultStudent;
      });
      return newState;
    }
    case CLEAR_STUDENT_STATE: {
      return defaultStudentState;
    }
    default: {
      return state;
    }
  }
};
